<template>
  <Header cur="Home" bgColor="#fff" />
  <div class="home-top" cur="Home" bgColor="#005AB8">
    <div>
      <div class="top-title">Your Financial Success, Our Commitment</div>
      <div class="top-content">
        <span style="color: #186dff">ABSOLUTE CREDIT KENYA LIMITED</span>
        <span>
          is a trusted provider of personal credit loan solutions, dedicated to
          helping everyone achieve their financial goals in a transparent and
          reliable manner.</span
        >
      </div>
      <div class="top-btn">GET STARTED</div>
    </div>
    <img class="top-img" src="../assets/bg1.webp" />
  </div>
  <div class="home-middle">
    <div class="middle-title">Our Services</div>
    <div>
      ABSOLUTE CREDIT KENYA LIMITED focuses on providing a range of professional
      financial services to meet the diverse needs of individuals and businesses
    </div>
    <div class="middle-list">
      <top-item
        v-for="item in serviceLists"
        :key="item.title"
        :info="item"
        btnName="Read More"
        btnLink="/service"
      />
    </div>
  </div>

  <div class="home-middle1">
    <img class="middle1-img" src="../assets/homePerson.webp" />
    <div class="middle1-right">
      <div class="middle-title">Why Choose Us?</div>
      <div class="middle-list">
        <left-item v-for="item in reasonList" :key="item.title" :info="item" />
      </div>
    </div>
  </div>
  <Footer />
</template>
<script setup>
import Header from "@/components/HeaderCom.vue";
import Footer from "@/components/FooterCom.vue";
import LeftItem from "@/components/LeftItem.vue";
import TopItem from "@/components/TopItem.vue";
const serviceLists = [
  {
    icon: "serviceIcon1",
    title: "Personal Loans",
    content:
      "Providing flexible and quick consumer, home, and emergency loans to meet daily and unexpected financial needs.",
  },
  {
    icon: "serviceIcon2",
    title: "Business Loans",
    content:
      "Offering diverse financing solutions for SMEs, including working capital and equipment loans, to support business growth and expansion.",
  },
  {
    icon: "serviceIcon3",
    title: "Investment Consulting",
    content:
      "Delivering professional wealth management, investment planning, and market analysis services based on clients' risk preferences and financial goals.",
  },
  {
    icon: "serviceIcon4",
    title: "Other Financial Services",
    content:
      "Providing comprehensive insurance, financial planning, and credit assessment services to ensure clients' financial security and health.",
  },
];
const reasonList = [
  {
    icon: "reasonIcon1",
    title: "Experience and Expertise",
    content:
      "With over four decades of experience, we have honed our expertise to provide top-notch financial services.",
  },
  {
    icon: "reasonIcon2",
    title: "Client-Centric Approach",
    content:
      "We place our clients at the center of everything we do, ensuring that our solutions are tailored to meet their specific needs.",
  },
  {
    icon: "reasonIcon3",
    title: "Innovative Solutions",
    content:
      "We continuously innovate and adapt to the changing financial landscape to offer the most relevant and effective solutions.",
  },
  {
    icon: "reasonIcon4",
    title: "Ethical Practices",
    content:
      "Integrity and transparency are the cornerstones of our business, and we are committed to upholding the highest ethical standards in all our dealings.",
  },
];
</script>
<style scoped lang="less">
.home-top {
  height: 450px;
  padding: 54px 114px 0;
  margin-bottom: 60px;
  display: flex;
  justify-content: space-between;
  .top-title {
    font-weight: bold;
    font-size: 33px;
    color: #333333;
    line-height: 36px;
    text-align: left;
  }

  .top-content {
    font-weight: normal;
    font-size: 18px;
    color: #333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
    margin: 44px 0;
  }

  .top-btn {
    display: inline-block;
    padding: 14px 44px;
    background: #186dff;
    border-radius: 23px;
    font-weight: bold;
    font-size: 11px;
    color: #ffffff;
    line-height: 14px;
    cursor: pointer;
  }

  .top-img {
    width: 382px;
    object-fit: contain;
    margin-left: 26px;
  }
}

.middle-title {
  font-weight: bold;
  font-size: 33px;
  color: #333333;
  line-height: 30px;
  text-align: center;
  margin-bottom: 15px;
}

.home-middle {
  background: #fff;
  margin-bottom: 80px;
  padding: 0 123px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  font-weight: bold;
  font-size: 14px;
  color: #999999;
  line-height: 18px;
  text-align: left;

  .middle-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 50px;
    .top-item {
      width: 23.5%;
      border-radius: 75px 0px 0px 0px;
      border: 0.5px solid #e8e8e8;
      justify-content: space-between;
      padding-bottom: 14px;
    }
    .top-item:nth-child(2n) {
      border-radius: 0px 75px 0px 0px;
    }
  }
}

.home-middle1 {
  display: flex;
  margin: 0 83px;
  padding: 50px 14px 10px 320px;
  background: #e3efff;
  border-radius: 6px 74px;
  position: relative;

  .middle1-right {
    background: #e3efff;
    border-radius: 6px 74px;

    .left-item {
      width: 48%;
    }
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;

    .middle-list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
  .middle1-img {
    width: 297px;
    object-fit: contain;
    position: absolute;
    left: 0;
    top: -52px;
  }
}
</style>